import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    courts: [],
    selectedCourt: null,
    registrations: [],
    slots: [],
    loading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
    },
};

const courtSlice = createSlice({
    name: 'court',
    initialState,
    reducers: {
        setCourts: (state, action) => {
            state.courts = action.payload;
        },
        setSelectedCourt: (state, action) => {
            state.selectedCourt = action.payload;
        },
        setRegistrations: (state, action) => {
            state.registrations = action.payload;
        },
        setSlots: (state, action) => {
            state.slots = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        addCourt: (state, action) => {
            state.courts.unshift(action.payload);
        },
        updateCourt: (state, action) => {
            const index = state.courts.findIndex((c) => c.id === action.payload.id);
            if (index !== -1) {
                state.courts[index] = action.payload;
            }
        },
        removeCourt: (state, action) => {
            state.courts = state.courts.filter((c) => c.id !== action.payload);
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const {
    setCourts,
    setSelectedCourt,
    setRegistrations,
    setSlots,
    setPagination,
    setLoading,
    setError,
    addCourt,
    updateCourt,
    removeCourt,
    clearError,
} = courtSlice.actions;

export default courtSlice.reducer;
